import {
	post, get, IProcessState, IProperty, EPropertyTypes, IToolsState, IServerResponse, IOutput, IError, ErrorHelper, OutputsHelper, IComponent, clone, EComponentTypes,
	IComponentDictionary, IAction, IdHelper, ComponentHelper, IRedirectCandidate, ERedirectCandidateType, IKeyValuePair, IConditionConfig, IQueryBuilderConfigRule,
	IValidateExpressionResponse, IComponentType, IOutputValue, IFieldConfig, EJourneyToolSearchType, ILoopConfigSummaryColumn, del, patch
} from '../helpers';
import { DEFAULT_JOURNEY_ID } from '../constants';
import store from '../store/store';
import types from '../store/types';
import { Promise } from 'es6-promise';
import { IOption } from './interfaces';

/**
 * Get the list of Output Types available
 * @private
 * @static
 * @returns {Promise<string[]>} A promise containing the list of types.
 * @memberOf OutputsHelper
 */
export let getTypes = (): Promise<string[]> => {

	let url: string = store.getState().cacheState.urls["getOutputs"];
	return ioPromise(get(url)
		.then(types => {

			return types;
		}), 'getOutputTypes');

};

/**
 * Get and store all Output templates.
 * @static
 * @returns {Promise<IOutput[]>} A promise containing a list of Output templates.
 * @memberOf OutputsHelper
 */
export let getTemplates = (): Promise<IOutput[]> => {

	let promise: Promise<IOutput[]> = new Promise((resolve, reject) => {

		getTypes()
			.then(types => {

				let requests: Promise<IOutput>[] = types.map(getTemplate);
				Promise.all(requests)
					.then(templates => {

						OutputsHelper.StoreTemplates(templates);
						resolve(templates);

					})
					.catch(reject);

			})
			.catch(reject);

	});

	return promise;

};

/**
 * Get an individual Output template.
 * @private
 * @static
 * @param {string} outputType 
 * @returns {Promise<IOutput>} A promise containing an Output template.
 * @memberOf OutputsHelper
 */
export let getTemplate = (outputType: string): Promise<IOutput> => {

	let url: string = store.getState().cacheState.urls["getOutputs"] + outputType;
	return ioPromise(get(url), 'getOutputTemplate ' + outputType)
		.then((template: IOutput) => {
			template.Name = template.Name || outputType;
			return template;
		});

};


export let getAuthConfig = (): Promise<any> => {
	return get('authentication.json');
}

export let getUrls = (): Promise<any> => {

	return get(
		'urls.json'
	);

};

export let getOperatorOptions = (): Promise<any> => {

	return ioPromise(get(
		store.getState().cacheState.urls["getOperators"]
	), 'getOperationOptions');

};

export let getOperator = (name: string): Promise<any> => {

	return ioPromise(get(
		store.getState().cacheState.urls["getOperators"] + name
	), 'getOperator ' + name);

};

export let getAction = (name: string): Promise<any> => {

	return ioPromise(get(
		store.getState().cacheState.urls["getActions"] + name
	), 'getAction');

};

export let getJourney = (journeyId: string): Promise<any> => {

	return ioPromise(get(
		store.getState().cacheState.urls["getJourney"] + journeyId
	), 'getJourney');

};

let postJourney = (journeyId: string, designerJourneyJSON): Promise<any> => {

	let url: string = store.getState().cacheState.urls["save"];
	let headers: { [key: string]: string } = { 'Content-Type': 'application/json' };
	let data: any = { designerJourneyJSON: JSON.stringify(designerJourneyJSON), id: journeyId };
	return ioPromise(post(url, data, headers), 'postJourney');

};

export let getControlTypesFromService = (): Promise<any> => {
	return ioPromise(get(
		store.getState().cacheState.urls["getControlTemplate"]
	), 'getControlTypesFromService');
};

export let getControlTemplate = (controlTypeName: string): Promise<any> => {

	return ioPromise(get(
		store.getState().cacheState.urls["getControlTemplate"] + controlTypeName
	), 'getControlTemplate ' + controlTypeName);

};

export let getComponentTemplatesFromService = (): Promise<any> => {

	return ioPromise(get(
		store.getState().cacheState.urls["getComponentTemplate"]
	), 'getComponentTemplatesFromService');

};

export let getComponentTemplateFromService = (componentTypeName: string): Promise<any> => {

	return ioPromise(get(
		store.getState().cacheState.urls["getComponentTemplate"] + componentTypeName
	), 'getComponentTemplateFromService ' + componentTypeName);

};

/**
 * Get list of available action types
 */
export const getActionsFromService = (): Promise<any[]> => {

	let url: string = store.getState().cacheState.urls["getActions"];
	return ioPromise(get(url), 'getActionsFromService');

};

/**
 * Get list of available option set for a given entity from CRM
 */
export const getEntityStateCodeFromService = (entityName: string): Promise<any> => {
	const entity = entityName ? entityName : '';

	// let url: string = store.getState().cacheState.urls["getActions"] + entityName;
	let url: string = store.getState().cacheState.urls["getFieldTypes"] + "/statecode/" + entity;
	// let url: string = store.getState().cacheState.urls["getFieldTypes"];
	return ioPromise(get(url), 'getFieldTypes');

};

/**
 * Get list of available option set for a given entity from CRM
 */
export const getStatusReasonFromService = (entityName: string, statecode: string): Promise<any> => {
	const entity = entityName ? entityName : '';
	// const entity = "incident";

	// let url: string = store.getState().cacheState.urls["getActions"] + entityName;
	let url: string = store.getState().cacheState.urls["getFieldTypes"] + "/statusreason/" + entity + "/" + statecode;
	// let url: string = store.getState().cacheState.urls["getFieldTypes"];
	return ioPromise(get(url), 'getFieldTypes');

};

/**
 * Get list of available option set for a given entity from CRM
 */
export const getEntityOptionSetFromService = (entityName: string): Promise<any> => {
	const entity = entityName ? entityName : '';

	// let url: string = store.getState().cacheState.urls["getActions"] + entityName;
	let url: string = store.getState().cacheState.urls["getFieldTypes"] + "/optionset/" + entity;
	// let url: string = store.getState().cacheState.urls["getFieldTypes"];
	return ioPromise(get(url), 'getFieldTypes');

};

/**
 * Get new layout panel instance
 */
export const getLayoutPanelFromService = (): Promise<any> => {

	// let url: string = store.getState().cacheState.urls["getActions"] + entityName;
	let url: string = store.getState().cacheState.urls["getControlTemplate"] + "/layoutPanel";
	// let url: string = store.getState().cacheState.urls["getFieldTypes"];
	return ioPromise(get(url), 'getLayoutPanelFromService');

};
/**
 * Get list of service types for a case entity from CRM
 */
export const getCaseServiceTypesFromService = (): Promise<any> => {

	// let url: string = store.getState().cacheState.urls["getActions"] + entityName;
	let url: string = store.getState().cacheState.urls["getCaseServiceTypes"];
	// let url: string = store.getState().cacheState.urls["getFieldTypes"];
	return ioPromise(get(url), 'getCaseServiceTypesFromService');

};
/**
 * Get list of available fields for a given entity from CRM
 */
export const getEntityFieldsFromService = (entityName: string): Promise<any> => {
	const entity = entityName ? entityName : '';

	// let url: string = store.getState().cacheState.urls["getActions"] + entityName;
	let url: string = store.getState().cacheState.urls["getFieldFromEntity"] + entity;
	// let url: string = store.getState().cacheState.urls["getFieldTypes"];
	return ioPromise(get(url), 'getEntityFieldsFromService');

};

/**
 * Get list of available views for a given entity from CRM
 */
export const getEntityViewsFromService = (entityName: string): Promise<any> => {
	const entity = entityName ? entityName : '';

	// let url: string = store.getState().cacheState.urls["getActions"] + entityName;
	let url: string = store.getState().cacheState.urls["getViewsFromEntity"] + entity;
	// let url: string = store.getState().cacheState.urls["getFieldTypes"];
	return ioPromise(get(url), 'getEntityViewsFromService');

};

/**
 * Get list of available views for a given entity from CRM
 */
export const getEntityFormsFromService = (entityName: string): Promise<any> => {
	const entity = entityName ? entityName : '';

	// let url: string = store.getState().cacheState.urls["getActions"] + entityName;
	let url: string = store.getState().cacheState.urls["getFormsFromEntity"] + entity;
	// let url: string = store.getState().cacheState.urls["getFieldTypes"];
	return ioPromise(get(url), 'getEntityFormsFromService');

};

/**
 * Get an individual Action Type template by Action Type name
 */
export const getActionTemplate = (actionType: string): Promise<any> => {

	let url: string = store.getState().cacheState.urls["getActions"] + actionType;
	return ioPromise(get(url), 'getActionTemplate');

};

export const getFieldTypesFromService = (): Promise<any> => {

	let url: string = store.getState().cacheState.urls["getFieldTypes"];
	return ioPromise(get(url), 'getFieldTypesFromService');

};

/**
 * Get a list of shared journeys that match the supplied search string
 */
export const getSharedJourneys = (searchTerm: string): Promise<any> => {

	let url: string = store.getState().cacheState.urls["getSharedJourney"] + searchTerm;
	return ioPromise(get(url), 'getSharedJourneys');

};

/**
 * gets the names of the shared journeys with the supplied IDs
 */
export const getSharedJourneyNames = (journeyIds: string): Promise<any> => {

	let url: string = store.getState().cacheState.urls["getSharedJourneyNames"] + journeyIds;
	return ioPromise(get(url), 'getSharedJourneyNames');

};

/**
 * gets the list of outputs associated with the supplied shared journey id
 */
export const getSharedJourneyOutputs = (journeyId: string): Promise<any> => {

	let url: string = store.getState().cacheState.urls["getSharedJourneyOutputs"] + journeyId + '?regenerateOutputIds=true';
	return ioPromise(get(url), 'getSharedJourneyOutputs');

};

/**
 * wrapper to use for all IO get and post functions
 * this ensures that the responses they produce are handled in a consistent fashion
 * return ioPromise(get(url), 'getSharedJourneyOutputs');
 */
function ioPromise<T>(promise: Promise<IServerResponse>, operation: string): Promise<T> {

	let p = new Promise<T>((resolve, reject) => {

		let exceptionThrownFromSuccess: boolean = true;

		promise.then(

			(response: IServerResponse) => {

				//parse the response and resolve if valid
				if (response.isValid && !response.error && !response.errorMessages && response.data) {
					if (response.data.toString() === response.data) { //string test
						if (operation === 'getExpressionFromJSON') {
							resolve(response.data);
						}
						else {
							resolve(JSON.parse(response.data));
						}
					}
					else {
						resolve(response.data);
					}
				}
				else {
					ioError(response, operation);
					reject();
				}

			},

			(response: IServerResponse) => {

				exceptionThrownFromSuccess = false;
				ioError(response, operation);
				reject();

			}

		).catch(

			(exceptionData) => {

				ioException(exceptionData, operation, exceptionThrownFromSuccess);
				reject();

			}

		);

	});

	return p;

};

const ioError = (response: IServerResponse, operation: string) => {

	let error: IError;

	if (response && response.error) {

		error = {
			code: response.error.code,
			message: response.error.message,
			operation: operation,
			errorMessages: response.errorMessages,
			exception: response.error.exception
		};

	}
	else {

		error = {
			code: -1,
			message: 'Unknown Error',
			operation: operation
		};

	}

	ErrorHelper.raiseError(error);

};

export const ioException = (exceptionData: Error, operation: string, exceptionThrownFromSuccess: boolean) => {

	let error: IError = {
		code: -1,
		message: exceptionData.message,
		operation: operation
	};

	ErrorHelper.raiseError(error);

};

export let saveHelper = (journeyId: string, toolsState: IToolsState, processState: IProcessState): Promise<any> => {

	journeyId = journeyId && journeyId.length ? journeyId : DEFAULT_JOURNEY_ID;
	let journeyDefinition = getJourneyJSON(toolsState, processState);

	// Journey definition is saving
	store.dispatch({ type: types.SET_TOOLS_SAVING, saving: true });

	// Save definition
	return postJourney(journeyId, journeyDefinition)
		.then(response => {

			// Journey has finished saving, regardless of the result
			store.dispatch({ type: types.SET_TOOLS_SAVING, saving: false });

			store.dispatch({
				type: types.UPDATE_JOURNEY_ID,
				journeyId: response.journeyId
			});
			store.dispatch({
				type: types.SET_SUPPRESS_HASH_CHANGE,
				suppressHashChange: true
			});
			window.location.hash = '#/' + response.journeyId;
		}
		).catch(error => {
			store.dispatch({ type: types.SET_TOOLS_SAVING, saving: false }); //saving operation has finished, even though it has failed
		});

};

export let publishHelper = (journeyId: string, toolsState: IToolsState, processState: IProcessState) => {

	return post(
		store.getState().cacheState.urls["publish"] + (journeyId.length ? '/' + journeyId : ''),
		{
			json: JSON.stringify(getJourneyJSON(toolsState, processState)),
			id: journeyId
		}, //data
		{ 'Content-Type': 'application/json' }, //headers
	);
};

export let getJourneyJSON = (toolsState: IToolsState, processState: IProcessState): any => {

	let journeyJSON: any = {};

	//set StartId
	journeyJSON.StartId = (processState.StartId && processState.StartId.length) ? processState.StartId : '';

	//set journey properties
	let journeyProperties: IProperty[] = [{
		Type: EPropertyTypes.string,
		Name: "Title",
		Value: toolsState.journeyTitle,
		Default: null,
		IsPrimary: false,
		ValueOptions: null,
	}, {
		Type: EPropertyTypes.boolean,
		Name: "Shared Journey",
		Value: !!toolsState.isSharedJourney,
		Default: false,
		IsPrimary: false,
		ValueOptions: null
	}, {
		Type: EPropertyTypes.boolean,
		Name: "Triage Journey",
		Value: !!toolsState.isTriageJourney,
		Default: false,
		IsPrimary: false,
		ValueOptions: null
	}, {
		Type: EPropertyTypes.boolean,
		Name: "Page Journey",
		Value: !!toolsState.isPageJourney,
		Default: false,
		IsPrimary: false,
		ValueOptions: null
	}, {
		Type: EPropertyTypes.boolean,
		Name: "Hide Steps",
		Value: !!toolsState.hideSteps,
		Default: false,
		IsPrimary: false,
		ValueOptions: null
	}, {
		Type: EPropertyTypes.boolean,
		Name: "Replace Guids",
		Value: !!toolsState.replaceGuids,
		Default: false,
		IsPrimary: false,
		ValueOptions: null
	}, {
		Type: EPropertyTypes.boolean,
		Name: "Save And Resume",
		Value: !!toolsState.isSaveAndResume,
		Default: false,
		IsPrimary: false,
		ValueOptions: null
	}, {
		Type: EPropertyTypes.number,
		Name: "Portal Authentication Level",
		Value: toolsState.portalAuthenticationLevel,
		Default: 586430001,
		IsPrimary: false,
		ValueOptions: null
	}, {
		Type: EPropertyTypes.string,
		Name: "Portal Time For Completion",
		Value: toolsState.portaltimeforcompletion,
		Default: "{Key:'586430001', Value:'5-10 Minutes'}",
		IsPrimary: false,
		ValueOptions: null
	},
	...toolsState.Properties
	];

	journeyJSON.Properties = journeyProperties;

	// Set components
	journeyJSON.Components = clone(processState.components);

	// Set global outputs
	journeyJSON.Outputs = store.getState().outputsState.globalOutputs;

	return journeyJSON;

};

let addSharedJourneyActions = (sharedJourney: IComponent, components: IComponentDictionary) => {

	if (sharedJourney.SharedJourney.OutputValues) {

		let inputs: IOutput[] = sharedJourney.SharedJourney.OutputValues.filter(o => o.CanBeSetByQueryString);

		if (!inputs.length) {
			return;
		}

		let cacheState = store.getState().cacheState;
		let firstComponent: IComponent;
		let lastComponent: IComponent;

		let cachedActionTemplate = cacheState.actionTemplates["Set Global Output Value"];
		let actionComponentTemplate = cacheState.componentTemplates.filter(c => c.Action)[0];

		// build a chain of action components. One for each input of the Shared Journey
		for (let i = 0; i < inputs.length; i++) {

			let input: IOutput = inputs[i];

			let newId = IdHelper.newGuid();
			let actionTemplate: IAction = clone(cachedActionTemplate); //TODO: use the appropriate action template. 
			actionTemplate.ComponentId = newId;
			let component: IComponent = clone(actionComponentTemplate);

			// configure OutputValue to have a GlobalOutputId of input.Id. This determines the Id of the Global Output being set by the action
			let output = actionTemplate.OutputValues[0];
			output.GlobalOutputId = input.Id;

			// set the Name and the StaticName of the OutputValue to match the Name and StaticName of the input
			output.Name = input.Name;
			output.StaticName = input.StaticName;

			// configure the Set Value property to have the InputValue specified for the given input in the Shared Journey configuration
			let setValueProperty = actionTemplate.Properties.filter(p => p.Name === 'Set Value')[0];
			setValueProperty.Value = input.InputValue || JSON.stringify({ text: '', markup: '' });

			component.Id = newId;
			component.Action = actionTemplate;

			//set firstComponent if it hasn't been set already
			if (!firstComponent) {
				firstComponent = component;
			}

			//set the NextComponent of the previous component
			if (lastComponent) {
				lastComponent.NextComponent = {
					ComponentId: newId
				};
			}

			components[newId] = component; //add the component to the dictionary

			//set the value of the lastComponent
			lastComponent = component;

		}

		// replace pointers to sharedJourney with pointers to firstComponent
		ComponentHelper.replaceNextComponentId(components, sharedJourney.Id, { ComponentId: firstComponent.Id });

		// make the NextComponent of lastComponent to be the sharedJourney
		lastComponent.NextComponent = {
			ComponentId: sharedJourney.Id
		};

	}

};

export let getRedirectCandidates = (searchTerm: string): Promise<IRedirectCandidate[]> => {

	let url: string = store.getState().cacheState.urls["getRedirectCandidates"] + searchTerm;
	return ioPromise(get(url), 'getRedirectCandidates');
}

export let getRedirectCandidateTypes = (): Promise<IOption[]> => {

	let url: string = store.getState().cacheState.urls["getRedirectCandidateTypes"];
	return ioPromise(get(url), 'getRedirectCandidateTypes');
}

export let getRedirectCandidateTemplate = (type: string): Promise<IOption[]> => {

	let url: string = store.getState().cacheState.urls["getRedirectCandidateTemplate"] + type;
	return ioPromise(get(url), 'getRedirectCandidateTemplate');
}

export let getExpressionFromJSON = (queryBuilderConfigRule: IQueryBuilderConfigRule): Promise<any> => {
	let headers: { [key: string]: string } = { 'Content-Type': 'application/json' };
	let url: string = store.getState().cacheState.urls["getExpressionFromJSON"];
	let data = { Config: JSON.stringify(queryBuilderConfigRule) };
	return ioPromise(post(url, data, headers), 'getExpressionFromJSON')

}

export let getJSONFromExpression = (expression: string): Promise<any> => {
	let journeyId: string = window.location.hash.substring(1) || DEFAULT_JOURNEY_ID;
	let headers: { [key: string]: string } = { 'Content-Type': 'application/json' };
	let url: string = store.getState().cacheState.urls["getJSONFromExpression"]
	let data = { Expression: encodeURIComponent(expression), JourneyId: journeyId };
	return ioPromise(post(url, data, headers), 'getJSONFromExpression');
}

export let getValidateExpression = (expression: string): Promise<IValidateExpressionResponse> => {
	let headers: { [key: string]: string } = { 'Content-Type': 'application/json' };
	let url: string = store.getState().cacheState.urls["getValidateExpression"];
	let data = { Expression: encodeURIComponent(expression) };
	return ioPromise(post(url, data, headers), 'getValidateExpression');
}

export let postValidateDesigner = (name: string, properties: IProperty[], componentType: IComponentType, outputValues: IOutputValue[], journeyOutputs: IOutputValue[], fields: IFieldConfig[], loopColumns: ILoopConfigSummaryColumn[]) => {

	let headers: { [key: string]: string } = { 'Content-Type': 'application/json' };
	let data = {
		name, properties, componentType, outputValues, journeyOutputs, fields, loopColumns
	};
	let url: string = store.getState().cacheState.urls["postValidateDesigner"];
	return post(url, data, headers);

}


/**
 * Get a list of journeys that match the supplied search string
 */
export const getJourneysByTerm = (searchTerm: string, eJourneyToolSearchType: EJourneyToolSearchType = null): Promise<any> => {

	let url: string = store.getState().cacheState.urls["getJourneysByTerm"] + '?searchTerm=' + searchTerm + '&eJourneyToolSearchType=' + eJourneyToolSearchType;
	return ioPromise(get(url), 'searchforjourneys');
};

export let upgradeJourney = (journeyId: string, upgradeId: string, isFinalRequest: Boolean) => {

	let headers: { [key: string]: string } = { 'Content-Type': 'application/json' };
	let data = {
		journeyId,
		upgradeId,
		isFinalRequest
	}
	let url: string = store.getState().cacheState.urls["upgradeJourney"];
	return post(url, data, headers);
}




export const getJourneyUpgradeLogging = (journeyId: string, upgradeId: string, getAdvancedLogging: boolean): Promise<any> => {

	let url: string = store.getState().cacheState.urls["upgradeLogging"] + "?journeyId=" + journeyId + "&upgradeId=" + upgradeId + "&getAdvancedLogging=" + getAdvancedLogging;
	return ioPromise(get(url), '');
};

export let checkJourneyIds = (journeyIdsList: string[]) => {

	let headers: { [key: string]: string } = { 'Content-Type': 'application/json' };
	let journeyIds: string = JSON.stringify(journeyIdsList);
	let data = {
		journeyIds
	}
	let url: string = store.getState().cacheState.urls["checkJourneyIds"];
	return post(url, data, headers);
}

export let queryByFetch = (fetchXML: string, journeyToolSearchType: EJourneyToolSearchType) => {

	let headers: { [key: string]: string } = { 'Content-Type': 'application/json' };
	let data = {
		fetchXML,
		journeyToolSearchType
	}
	let url: string = store.getState().cacheState.urls["queryByFetchXml"];
	return post(url, data, headers);
}


export let cancelUpgrade = (upgradeId: string) => {

	let headers: { [key: string]: string } = { 'Content-Type': 'application/json' };
	let data = {
		upgradeId,
	}
	let url: string = store.getState().cacheState.urls["cancelUpgrade"];
	return post(url, data, headers);
}

export const getAdminToolVersion = (): Promise<any> => {
	let url: string = store.getState().cacheState.urls["getAdminToolVersion"];
	return ioPromise(get(url), '');
};


export let uploadZip = (file: any) => {

	let headers: { [key: string]: string } = {};
	var data = file;
	let url: string = store.getState().cacheState.urls["zipFileUpload"];
	return post(url, data, headers, true);

}

export let importZip = (file: any, upgradeId: string) => {

	let headers: { [key: string]: string } = {};
	let data: any = file;

	data.append('upgradeid', upgradeId);

	let url: string = store.getState().cacheState.urls["zipImport"];
	return post(url, data, headers, true);

}

export let createZip = (journeyIds: string[], runId: string, zipNumber: number, includeRelatedServiceTypes: boolean) => {

	let headers: { [key: string]: string } = { 'Content-Type': 'application/json' };
	var data = {
		journeyIds,
		runId,
		zipNumber,
		includeRelatedServiceTypes
	};

	let url: string = store.getState().cacheState.urls["downloadZip"];
	return post(url, data, headers, false, true);
}

export const getAdminToolList = (): Promise<any> => {

	let url: string = store.getState().cacheState.urls["getAdminToolList"]
	return ioPromise(get(url), 'getAdminToolList');
};

export const getJourneyEngineSettingsList = (): Promise<any> => {

	let url: string = store.getState().cacheState.urls["journeyEngineSettings"] + '/getjesettingslist';
	return ioPromise(get(url), 'journeyEngineSettings');
};

export const updateJourneyEngineSettingsList = (JourneyEngineSettings: any): Promise<any> => {
	let headers: { [key: string]: string } = { 'Content-Type': 'application/json' };

	let url: string = store.getState().cacheState.urls["journeyEngineSettings"] + '/updatejesetting';
	let data = JourneyEngineSettings;

	return patch(url, data, headers);
};
export const createJourneyEngineSetting = (JourneyEngineSettings: any): Promise<any> => {
	let headers: { [key: string]: string } = { 'Content-Type': 'application/json' };

	let url: string = store.getState().cacheState.urls["journeyEngineSettings"] + '/createjesetting';
	let data = JourneyEngineSettings;

	return patch(url, data, headers);
};

export const removeFromJourneyEngineSettingsList = (JourneyEngineSettingsId: any): Promise<any> => {
	let headers: { [key: string]: string } = { 'Content-Type': 'application/json' };

	let url: string = store.getState().cacheState.urls["journeyEngineSettings"] + "/deletejesetting";
	// let deleteJESettingsRequest: any = {
	// 	JourneyEngineSettingsId: JourneyEngingeSettingsId
	// };
	let data = {
		JourneyEngingeSettingsId: JourneyEngineSettingsId
	}

	// deleteJESettingsRequest.append('JourneyEngingeSettingsId', JourneyEngingeSettingsId);
	// let header = {
	// 	method: 'DELETE',
	// 	headers: {
	// 		'Content-Type': 'application/json'
	// 	},
	// 	body: JSON.stringify(deleteJESettingsRequest)
	// };
	return del(url, data, headers);

	// return del(url, deleteJESettingsRequest, {}).then(response => {
	// 	return 'success'
	// }).catch(error => {
	// 	return error
	// });
};

export let rollbackJourney = (upgradeId: string, journeyId: string, runId: string, isFinalRequest: Boolean) => {

	let headers: { [key: string]: string } = { 'Content-Type': 'application/json' };
	let data = {
		runId: runId,
		rollbackJourneys: {
			journeyId,
			upgradeId,
			isFinalRequest
		}
	}
	let url: string = store.getState().cacheState.urls["rollbackJourney"];
	return post(url, data, headers);
}


// WEBPACK FOOTER //
// ./source/ts/helpers/io.ts